import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import { ReactComponent as SearchSvg } from 'assets/svgs/icn_search.svg'

interface Props {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SearchCom = ({onChange}: Props) => {
    return <SearchWrap>
        <InputWrap placeholder="Start typing" onChange={onChange}></InputWrap>
        <SearchSvgWrap></SearchSvgWrap>
    </SearchWrap>
}

const SearchWrap = styled(StyledContainer)`
    position: relative;
    height: 62px;
    border-radius: 9px;
    background-color: #F4F5F5;
    overflow: hidden;
    padding: 0 60px 0 16px;
`

const InputWrap = styled.input`
    height: 100%;
    width: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;

    font-size: 20px;
    font-weight: 600;
    line-height: 20px;
    font-family: RoobertSemiBold;

    &::placeholder {
        color: #CACCCE;
    }

`

const SearchSvgWrap = styled(SearchSvg)`
    width: 16px;
    height: 16px;
    position: absolute;
    top: 23px;
    right: 23px;
`

export default SearchCom